module.exports = __webpack_public_path__ + "8b0b1ada297314df.png";